import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { safe, isNullOrUndefined, addItemToGoogleTracking } from "../../utils";
import { IPageProperties } from "../../models";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { Tooltip } from "../../assets/Tooltip/Tooltip";
import { NumberFormat, Disclaimer } from "../../assets";
import * as moment from "moment";

const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
const overrideStyles = require('./overrides/tooltipOverrides.pcss');
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const FaAngleUp = require('react-icons/lib/fa/angle-up');

interface IState {
    visible: boolean;
}

export class PageCharges extends React.Component<IPageProperties, IState>{
    constructor(props) {
        super(props);

        this.getTooltip = this.getTooltip.bind(this);
        this.state = { visible: false };
        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    toggle(event?) {
        event.stopPropagation();
        let visible = !this.state.visible;
        let { appParams, shareClass } = this.props;

        addItemToGoogleTracking(appParams, "fund_page_charges_tab", { eventCategory: shareClass.clientCode, eventAction: "Ongoing Charges", eventLabel: visible ? 'expand' : 'collapse' });

        this.setState({ visible }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggle();
    }

    getTooltip(text) {
        let { shareClass } = this.props;
        let [disclaimer] = safe(() => shareClass.disclaimers[text], []);

        if (disclaimer && !disclaimer.is_deleted) {
            return <Tooltip text={ disclaimer.disclaimer } />;
        }
    }

    render() {
        let { isLoading, shareClass, fund, appParams, disclaimers } = this.props;
        if (!shareClass || !shareClass.latestTimeseriesValues) {
            return null;
        }

        let isDTC = appParams.clienttype === "dtc";

        let { charges } = shareClass.latestTimeseriesValues;
        let visibility = !this.state.visible ? '' : styles.active;

        let internalClasses = {
            caret: `${ styles.caret } ${ visibility }`,
            dropdown: `${ styles.dropdownContent } ${ visibility }`
        }
        let numberFormatOptions = { emptyValue: "0.00" };

        return (
            <div className={ styles.wrapper }>
                <div className={ styles.fundChargesContainer }>
                    <BackToTop styles={ backToTopstyles } />
                    <div className={ styles.row }>
                        <div className={ styles.colXs12 }>
                            <h2 className={ styles.title + ' ' + styles.reasons }>Fund Charges</h2>
                        </div>

                        <div className={ styles.colXs12 + ' ' + styles.colMd6 }>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>As at date&nbsp;{ this.getTooltip("") }</td>
                                        <td className={ styles.numbers }>{ safe(() => moment(charges.date).format("DD.MM.YYYY"), null) }</td>
                                    </tr>
                                    { (() => {
                                        let entryCharge = safe(() => charges.entry_charge.toString(), null);
                                        let hideStyle = {display:'none'};
                                        if (!isDTC && !isNullOrUndefined(entryCharge)) {
                                            return (
                                                <tr style={hideStyle}>
                                                    <td>Entry charge (%)&nbsp;{ this.getTooltip("tooltip_entry_charge") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ safe(() => charges.entry_charge, null) }</NumberFormat></td>
                                                </tr>

                                            );
                                        }
                                    })() }
                                    { (() => {
                                        let ongoingValue;
                                        let estChargesActual = safe(() => charges.estimate_actual_not_available, null);
                                        if (!isNullOrUndefined(estChargesActual) && estChargesActual === "Estimate") {
                                            ongoingValue = <em><NumberFormat options={ numberFormatOptions }>{ safe(() => charges.total_ongoing_charges, null) }</NumberFormat> *</em>;
                                        } else {
                                            ongoingValue = <NumberFormat options={ numberFormatOptions }>{ safe(() => charges.total_ongoing_charges, null) }</NumberFormat>;
                                        }
                                        return (
                                            <tr className={ styles.toggleTableRows } onClick={ this.toggle }>
                                                <td><span className={ styles.caret + ' ' + styles.active } onClick={ this.toggle }>{ this.state.visible ? <FaAngleDown /> : <FaAngleUp /> }</span> Ongoing charges (%)&nbsp;{ this.getTooltip("tooltip_ongoing_charge") }</td>
                                                <td className={ styles.numbers }>{ ongoingValue }</td>
                                            </tr>
                                        );
                                    })() }
                                    { (() => {
                                        if (this.state.visible) {
                                            return (
                                                <tr>
                                                    <td colSpan={ 2 }>
                                                        <table style={ { marginTop: "-2px", paddingTop: 0 } }>
                                                            <tbody>
                                                                { (() => {
                                                                    let investmentManagement = safe(() => charges.investment_management.toString(), null);
                                                                    if (true) {
                                                                        return (
                                                                            <tr style={ { backgroundColor: "transparent" } }>
                                                                                <td className={ styles.indent }><span>Annual management charge (%)</span>&nbsp;{ this.getTooltip("tooltip_investment_management") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ safe(() => charges.investment_management, null) }</NumberFormat></td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                })() }
                                                                { (() => {
                                                                    let oversightAndOther = safe(() => charges.oversight_and_other.toString(), null);
                                                                    if (!isNullOrUndefined(oversightAndOther)) {
                                                                        return (
                                                                            <tr>
                                                                                <td className={ styles.indent }>Custodian charges (%)&nbsp;{ this.getTooltip("tooltip_oversight_and_other_independent_services") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ oversightAndOther }</NumberFormat></td>
                                                                            </tr>

                                                                        );
                                                                    }
                                                                })() }
                                                                { (() => {
                                                                    let administration = safe(() => charges.administration.toString(), null);
                                                                    if (!isNullOrUndefined(administration)) {
                                                                        return (
                                                                            <tr>
                                                                                <td className={ styles.indent }>Admin charges (%)&nbsp;{ this.getTooltip("tooltip_administration") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ administration }</NumberFormat></td>
                                                                            </tr>

                                                                        );
                                                                    }
                                                                })() }
                                                                { (() => {
                                                                    let ongoingChargesUnderlying = safe(() => charges.ongoing_charges_underlying.toString(), null);
                                                                    if (!isNullOrUndefined(ongoingChargesUnderlying)) {
                                                                        return (
                                                                            <tr>
                                                                                <td className={ styles.indent }>Ongoing charges from underlying funds (%)&nbsp;{ this.getTooltip("tooltip_ongoing_charges_from_underlying_funds") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ ongoingChargesUnderlying }</NumberFormat></td>
                                                                            </tr>

                                                                        );
                                                                    }
                                                                })() }
                                                                { (() => {
                                                                    let shareclassHedging = safe(() => charges.shareclass_hedging.toString(), null);
                                                                    if (!isNullOrUndefined(shareclassHedging)) {
                                                                        ;
                                                                        return (
                                                                            <tr>
                                                                                <td className={ styles.indent }>Share class hedging (%)&nbsp;{ this.getTooltip("tooltip_ongoing_charges_from_underlying_funds") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ shareclassHedging }</NumberFormat></td>
                                                                            </tr>

                                                                        );
                                                                    }
                                                                })() }
                                                                { (() => {
                                                                    let propertyCharges = safe(() => charges.property_expenses.toString(), null);
                                                                    if (!isNullOrUndefined(propertyCharges)) {
                                                                        return (
                                                                            <tr>
                                                                                <td className={ styles.indent }>Property charges (%)&nbsp;{ this.getTooltip("tooltip_property_expenses") }</td>
                                                                                <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ propertyCharges }</NumberFormat></td>
                                                                            </tr>

                                                                        );
                                                                    }
                                                                })() }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })() }
                                    { (() => {
                                        let exitCharge = safe(() => charges.exit_charge.toString(), null);
                                        if (!isDTC && !isNullOrUndefined(exitCharge)) {
                                            return (
                                                <tr>
                                                    <td>Exit charge (%)&nbsp;{ this.getTooltip("tooltip_exit_charge") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ exitCharge }</NumberFormat></td>
                                                </tr>
                                            );
                                        }
                                    })() }
                                    {/* { (() => {
                                        let directPortfolioCosts = safe(() => charges.direct_portfolio_costs.toString(), null);
                                        if (!isNullOrUndefined(directPortfolioCosts)) {
                                            return (
                                                <tr>
                                                    <td>Portfolio transaction costs (%)&nbsp;{ this.getTooltip("tooltip_direct_portfolio_transaction_costs") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ directPortfolioCosts }</NumberFormat></td>
                                                </tr>

                                            );
                                        }
                                    })() } */}
                                    { (() => {
                                        let PortfolioCosts = safe(() => charges.total_portfolio_trx_costs.toString(), null);
                                        if (!isNullOrUndefined(PortfolioCosts)) {
                                            return (
                                                <tr>
                                                    <td>Portfolio transaction costs (%)&nbsp;{ this.getTooltip("tooltip_portfolio_transaction_costs") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ PortfolioCosts }</NumberFormat></td>
                                                </tr>

                                            );
                                        }
                                    })() }
                                    {/* { (() => {
                                        let indirectPortfolioCosts = safe(() => charges.indirect_portfolio_costs.toString(), null);
                                        if (!isNullOrUndefined(indirectPortfolioCosts)) {
                                            return (
                                                <tr>
                                                    <td>Indirect portfolio transaction costs (%)&nbsp;{ this.getTooltip("tooltip_indirect_portfolio_transaction_costs") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ indirectPortfolioCosts }</NumberFormat></td>
                                                </tr>

                                            );
                                        }
                                    })() } */}
                                    { (() => {
                                        let performanceFee = safe(() => charges.performance_fee.toString(), null);
                                        if (!isNullOrUndefined(performanceFee) && shareClass.properties.fund_key === "MAEP") {
                                            return (
                                                <tr>
                                                    <td>Performance fee (%)&nbsp;{ this.getTooltip("tooltip_performance_fee") }</td>
                                                    <td className={ styles.numbers }><NumberFormat options={ numberFormatOptions }>{ performanceFee }</NumberFormat></td>
                                                </tr>

                                            );
                                        }
                                    })() }
                                    {/*<tr>
                                        <td className={ styles.blank }></td>
                                        <td className={ styles.blank }></td>
                                    </tr>*/}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    { (() => {
                        if (!isNullOrUndefined(shareClass.disclaimers["shareclass_fundcharges"]) && !shareClass.disclaimers["shareclass_fundcharges"][0].is_deleted && charges && charges.estimate_actual_not_available.toLowerCase() === "estimate") {
                            return (
                                <div className={ styles.disclaimer }>
                                    <Disclaimer appParams={ appParams } disclaimer={ shareClass.disclaimers["shareclass_fundcharges"] }></Disclaimer>
                                </div>
                            );
                        }
                    })() }
                </div> {/*ends the fundChargesContainer */ }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageCharges/index.tsx